/* eslint-disable no-nested-ternary */
import { Suspense, lazy } from 'react';
import redeemCoverImg from '@/assets/images/gift-header.jpg';
import Picture from '@/components/globals/picture/Picture';
import IMAGES from '@/database/plansImages';
import usePlan from '@/hooks/usePlan';
import { useAppSelector } from '@/hooks/useRedux';
import getSelectedPlan from '@/utils/getSelectedPlan';
import styles from './CoverTopGeneric.module.scss';
import HomeTitle, { HomeTitleAloy } from './homeTitle/HomeTitle';

const RedeemGiftTitle = lazy(() => import('./redeemGiftTitle/RedeemGiftTitle'));

const CoverTopGeneric = () => {
    const { planConfig } = usePlan();
    const { isNationalPlan, isAloyPlan } = getSelectedPlan(planConfig.id);
    const isRedeemingAGift = useAppSelector((state) => state.gift.isRedeemingAGift);

    return (
        <div className={styles.background}>
            {isRedeemingAGift ? (
                <Picture desktopImg={redeemCoverImg} mobileImg={redeemCoverImg} className={styles.coverImage} />
            ) : (
                <Picture
                    // desktopImg={isDestinationPlan ? destinationPlanConfig?.cover.large : planConfig.cover.large}
                    // desktopWebp={
                    //     isDestinationPlan ? destinationPlanConfig?.cover.largeWebp : planConfig.cover.largeWebp
                    // }
                    // mobileImg={isDestinationPlan ? destinationPlanConfig?.cover.small : planConfig.cover.small}
                    // mobileWebp={isDestinationPlan ? destinationPlanConfig?.cover.smallWebp : planConfig.cover.smallWebp}
                    desktopImg={IMAGES.summer}
                    desktopWebp={IMAGES.summerWebp}
                    mobileImg={IMAGES.summerSmall}
                    mobileWebp={IMAGES.summerSmallWebp}
                    className={styles.coverImage}
                    highPriority
                />
            )}

            {!isAloyPlan && <div className={styles.darkGradient} />}
            {isNationalPlan && (
                <div className={styles.newPlanTagContainer}>
                    <div className={styles.newPlanTag} />
                </div>
            )}
            {isRedeemingAGift ? (
                <Suspense fallback={null}>
                    <RedeemGiftTitle />
                </Suspense>
            ) : isAloyPlan ? (
                <HomeTitleAloy />
            ) : (
                <HomeTitle />
            )}
        </div>
    );
};

export default CoverTopGeneric;
